export default __webpack_public_path__ + "af6472cd2c3fb31c376601e4eea86eab.png";